import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '@/composables/useAuth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
    },
    {
      path: '/portal',
      component: () => import('@/views/portal/PortalLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        { path: '', redirect: { name: 'dashboard' } },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: () => import('@/views/portal/Dashboard.vue'),
        },
        {
          path: 'reportingagency/clients',
          name: 'reporting-agency-clients',
          component: () => import('@/views/portal/ReportingAgency/Clients.vue'),
        },
        {
          path: 'internal/integrators',
          name: 'internal-integrators',
          component: () => import('@/views/portal/Internal/Integrators.vue'),
        },
        {
          path: 'internal/reportingagencies',
          name: 'internal-reporting-agencies',
          component: () => import('@/views/portal/Internal/ReportingAgencies.vue'),
        },
        {
          path: 'internal/reportingagencies/:id',
          name: 'internal-reporting-agency',
          component: () => import('@/views/portal/Internal/ReportingAgency.vue'),
        },
        {
          path: 'internal/invoices',
          name: 'internal-invoices',
          component: () => import('@/views/portal/Internal/Invoices.vue'),
        },
        {
          path: 'reportingagency/payment-info',
          name: 'reporting-agency-payment-info',
          component: () => import('@/views/portal/ReportingAgency/ReportingAgencyPaymentInfo.vue'),
        },
        {
          path: 'reportingagency/invoices',
          name: 'reporting-agency-invoices',
          component: () => import('@/views/portal/ReportingAgency/ReportingAgencyInvoices.vue'),
        },
        {
          path: 'reportingagency/users',
          name: 'reporting-agency-users',
          component: () => import('@/views/portal/ReportingAgency/ReportingAgencyUsers.vue'),
        },
        {
          path: 'internal/users',
          name: 'internal-users',
          component: () => import('@/views/portal/Internal/Users.vue'),
        }
      ],
    },
    {
      path: '/set-password',
      name: 'set-password',
      component: () => import('@/views/SetPassword.vue'),
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  if (!to.meta.requiresAuth) return true

  const { checked, fetchMe, user } = useAuth()
  if (!checked.value) await fetchMe()

  if (!user.value) return '/'
  return true
})

export default router
